import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { PATH_ACTIVIDAD, PATH_COLABORADOR_DETAIL, PATH_NEGOCIOS } from '../../../navigation/navigation.module';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { PermisosService, COM_DIALOG_STATE, PERM_ACCIONES_ID } from '../../../services';
import { ExcelExporterService } from '../../../services/excel-exporter-service';
import { NavigationService } from '../../../services/navigation-service';
import { ComunicacionService } from '../../../services/comunicacion-service';
import { SpinnerService } from '../../../services/spinner-service';
import { DialogsService } from '../../../services/dialogs-service';

@Component({
  selector: 'app-comunicacion-detail',
  templateUrl: './comunicacion-detail.component.html',
  styleUrls: ['./comunicacion-detail.component.scss']
})
export class ComunicacionDetailComponent implements OnInit {

  public dataValid = false;
  public userIsAutor = false;

  constructor(private route: ActivatedRoute,
              private navService: NavigationService,
              private location: Location,
              private router: Router,
              private comunicacionService: ComunicacionService,
              private dialogsService: DialogsService,
              private spinnerService: SpinnerService,
              private excelExporterService: ExcelExporterService,
              private permisosService: PermisosService) {
    this.permisosService.verificarAccesoDeURL();
  }

  public comunicacion: any;
  public fileFullPath: string;

  public fileLabel = '';

  public comunicacionDescripcion = '';
  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  ngOnInit() {
    this.loadData();
  }

  editComunicacion() {
    this.dialogsService.showNewComunicacionDialog(this.comunicacion, COM_DIALOG_STATE.EDIT)
      .subscribe(res => {
        if (res) {
          this.loadData();
        }
      });
  }

  navigateBack() {
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_ACTIVIDAD + '/comunicaciones');
    }
  }

  getTooltip(col, tool) {
    if (tool === 'leido') {
      return col.Leido ? 'Leído: ' + moment(col.FechaLeido).format('DD/MM/YY HH.mm') + 'hs'  : 'No Leído';
    } else if (tool === 'desc') {
      return col.Descarga ? 'Descargado: ' + moment(col.FechaDescarga).format('DD/MM/YY HH.mm') + 'hs' : 'No Descargado';
    }
  }

  goToColaborador(id = 0) {

    console.log(id);

    if (id === 0) {
      this.router.navigate([PATH_COLABORADOR_DETAIL, this.comunicacion.AutorId]);
    } else if (id !== 0) {
      this.router.navigate([PATH_COLABORADOR_DETAIL, id]);
    }
  }

  loadData() {
    let comunicacionId = 0;
    this.route.params.subscribe(params => {
      comunicacionId = this.route.snapshot.params['id'];
    });

    this.comunicacionService.getComunicacionById(comunicacionId)
      .subscribe(response => {
        console.log(response);
        if (response != null) {
          this.dataValid = true;
          this.comunicacion = response;
          this.userIsAutor = this.comunicacion.AutorId.toString() === localStorage.getItem('userId');
          this.fileFullPath = environment.BASE_URL + this.comunicacion.ComunicacionPath;

          if (this.comunicacion.ComunicacionPath) {
            this.fileLabel = 'Archivo Adjunto: ' + this.comunicacion.ComunicacionPath;
          }
          this.comunicacionDescripcion = '';
          if (this.comunicacion.Descripcion) {
            this.comunicacionDescripcion = this.comunicacion.Descripcion.replace(new RegExp('\n', 'g'), '<br />');
          }
        } else {
          this.dataValid = false;
        }

      });
  }

  download() {
    this.spinnerService.setShowFlag(true);
      this.comunicacionService.downloadFile(this.comunicacion.Id)
      .subscribe(x =>{
        this.spinnerService.setShowFlag(false);
          this.comunicacionService.markAsDownloaded(this.comunicacion.Id)
            .subscribe(x => {
              if (x) {
                // refrescar datos para reflejar descarga en el listado de colaboradores
                this.loadData();
              }
            });
      },
        (err) => {
          this.spinnerService.setShowFlag(false);
        });
  }

  deleteComunicacion() {
    console.log('delete');
    this.dialogsService.confirm('¿Está seguro de que desea Eliminar esta Comunicación?', null, 'Si, Eliminar', 'No, Cancelar')
      .subscribe(value => {

        if (!value){
          return;
        }

        this.comunicacionService.deleteComunicacion(this.comunicacion.Id)
          .subscribe(res => {
            if (res) {
              this.navigateBack();
            }
          });
      });
  }

  onExportaAsExcel() {
    const titles = ['Nombre y Apellido', 'Fecha de lectura', 'Fecha de descarga'];
    let data = [];

    this.comunicacion.Colaboradores.forEach(item => {
      let row = [];
      row.push(item.Nombre);

      if (item.Leido) {
        row.push(moment(item.FechaLeido).format('DD-MM-YY HH:mm:ss').toString());
      } else {
        row.push('No Leído');
      }

      if (item.Descarga) {
        row.push(moment(item.FechaDescarga).format('DD-MM-YY HH:mm:ss').toString());
      } else {
        row.push('No Descargado');
      }
      data.push(row);
    });

    this.excelExporterService.exportComunicacionExcel(titles, data, 'Tracking-' + this.comunicacion.Titulo.substring(0, 9));
  }

  cloneComunicacion() {
    const comunicacion = {Id: this.comunicacion.Id};
    this.dialogsService.showNewComunicacionDialog(comunicacion, COM_DIALOG_STATE.CLONE)
      .subscribe( res => {
        if (res) {
          this.router.navigateByUrl('/' + PATH_ACTIVIDAD + '/comunicaciones');
        }
      });
  }

  permisoAutorizado(id) {
    return this.permisosService.permisoAutorizado(id);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/comunicacion-detail/comunicacion-detail.component.ts